import QRCodeStyling from "qr-code-styling";
import jsPDF from "jspdf";

export const deviceUtils = {
  isTracker: (deviceType) => {
    const trackerTypes = [1, 4, 7, 14, 15, 16, 41, 44];
    return trackerTypes.includes(deviceType);
  },

  getDeviceTypeLabel: (deviceType) => {
    const deviceTypeLabels = {
      1: "GPS Tracker",
      4: "Asset Tracker",
      7: "Vehicle Tracker",
      14: "Pet Tracker",
      15: "Personal Tracker",
      16: "Cargo Tracker",
      41: "Environmental Sensor",
      44: "IoT Device",
      // Add more device types as needed
    };
    return deviceTypeLabels[deviceType] || "Unknown Device";
  },

  getDeviceStatus: (device) => {
    if (!device.lastSeen) return "offline";

    const lastSeenDate = new Date(device.lastSeen);
    const now = new Date();
    const diffInMinutes = (now - lastSeenDate) / (1000 * 60);

    if (diffInMinutes < 30) return "online";
    if (diffInMinutes < 120) return "recent";
    return "offline";
  },

  formatDeviceName: (device) => {
    return device.name || device.deviceId || "Unnamed Device";
  },

  _makeQRCode: (claimCode) =>
    new QRCodeStyling({
      width: 300,
      height: 300,
      margin: 20,
      type: "svg",
      data: claimCode,
      dotsOptions: {
        color: "#4267b2",
        type: "rounded",
      },
      backgroundOptions: {
        color: "#ffffff",
      },
    }),

  renderQRCode: (claimCode, element) => {
    element.innerHTML = "";
    deviceUtils._makeQRCode(claimCode).append(element);
  },

  downloadQRCode: async (claimCode, deviceName) => {
    const QR_MM = 80;
    const QR_SIZE = 600;
    const QR_MARGIN = 40;
    const PAGE_MARGIN = 8;
    const PAD = 4;
    const BORDER_WIDTH = 0.35;

    const container = document.createElement("div");
    const qr = new QRCodeStyling({
      width: QR_SIZE,
      height: QR_SIZE,
      margin: QR_MARGIN,
      type: "canvas",
      data: claimCode,
      dotsOptions: { color: "#000000", type: "rounded" },
      backgroundOptions: { color: "#ffffff" },
    });
    qr.append(container);
    await new Promise((r) => setTimeout(r, 150));
    const imgData = container.querySelector("canvas").toDataURL("image/png");

    // measure text to make box dynamic
    const tmpPdf = new jsPDF({ unit: "mm" });
    tmpPdf.setFontSize(16);
    tmpPdf.setFont("courier", "bold");
    const textW = tmpPdf.getTextWidth(claimCode);

    const boxW = Math.max(QR_MM, textW) + PAD * 2;
    const boxH = QR_MM + 10 + PAD * 2;
    const boxX = PAGE_MARGIN;
    const boxY = PAGE_MARGIN;
    const pdf = new jsPDF({ unit: "mm", format: "a4" });

    pdf.addImage(
      imgData,
      "PNG",
      boxX + (boxW - QR_MM) / 2,
      boxY + PAD,
      QR_MM,
      QR_MM
    );

    pdf.setFontSize(16);
    pdf.setFont("courier", "bold");
    pdf.text(claimCode, boxX + boxW / 2, boxY + PAD + QR_MM + 8, {
      align: "center",
    });

    pdf.setDrawColor(0);
    pdf.setLineWidth(BORDER_WIDTH);
    pdf.rect(
      boxX + BORDER_WIDTH / 2,
      boxY + BORDER_WIDTH / 2,
      boxW - BORDER_WIDTH,
      boxH - BORDER_WIDTH
    );

    pdf.save(`${deviceName}.pdf`);
  },
};
